import { DeleteAccountPanel } from "@frontend/components/settings/delete-account";
import { LegalDoc } from "@frontend/components/site/legal-doc";
import {
  DELETE_ACCOUNT_META,
  DELETE_ACCOUNT_SECTIONS,
} from "@frontend/components/site/legal-data";
import { branding } from "@creators/backend/lib/config";
import { Seo } from "@frontend/lib/seo";

export function DeleteAccountPage() {
  return (
    <main>
      <Seo
        title={DELETE_ACCOUNT_META.title}
        description={DELETE_ACCOUNT_META.description}
        path={DELETE_ACCOUNT_META.path}
      />
      <div className="mx-auto w-full max-w-3xl px-4 pt-8 sm:pt-10">
        <DeleteAccountPanel />
      </div>
      <LegalDoc
        eyebrow="Legal"
        title="Delete your account"
        updated={DELETE_ACCOUNT_META.updated}
        intro={`Permanently delete your ${branding.name} account and associated personal data from Settings or below when signed in. This page is the account-deletion path for the website and mobile apps.`}
        sections={DELETE_ACCOUNT_SECTIONS}
      />
    </main>
  );
}
